<template lang='pug'>
.report-utilities-monitor
  h1 水电监控

  br

  .ui.statistics
    .statistic
      .value {{avarage.water.toFixed(2)}} 吨
      .label 30天人均冷水用量
    .statistic
      .value {{avarage.hot_water.toFixed(2)}} 吨
      .label 30天人均热水用量
    .statistic
      .value {{avarage.electricity.toFixed(2)}} 度
      .label 30天人均电用量

  br
  br

  table.ui.celled.structured.table
    thead
      tr
        th.center.aligned(rowspan=2) 房<br>號
        th.center.aligned(rowspan=2) 当前住客
        th.center.aligned(rowspan=2) 住客<br>人数
        th.center.aligned(rowspan=2) 合同<br>数量
        th.center.aligned(rowspan=2) 入住<br>天数
        th.center.aligned(colspan=4) 入住时水电
        th.center.aligned(colspan=4) 出租期间充值水电
        th.center.aligned(rowspan=2) 备注
        th.center.aligned(colspan=4) 平均用量 /30天/人
      tr
        th.center.aligned 冷水
        th.center.aligned 热水
        th.center.aligned 电
        th.center.aligned 厨房

        th.center.aligned 冷水
        th.center.aligned 热水
        th.center.aligned 电
        th.center.aligned 厨房

        th.center.aligned 冷水
        th.center.aligned 热水
        th.center.aligned 电
        th.center.aligned 厨房

    tbody
      tr(v-for='record in details', :class='{disabled: record.untrusted}', v-if='record.contracts.length')
        td.center.aligned {{record.no}}
        td.collapsing.customers {{$formatters.customers_summary(record.customers)}}
        td.center.aligned {{record.customers.length}}
        td.center.aligned {{record.contracts.length}}
        td.center.aligned {{record.rented_days}}

        td.center.aligned.shadow {{record.room_utilities.water}}
        td.center.aligned.shadow {{record.room_utilities.hot_water}}
        td.center.aligned.shadow {{record.room_utilities.electricity}}
        td.center.aligned.shadow {{record.room_utilities.kitchen}}

        td.center.aligned {{record.charges.water}}
        td.center.aligned {{record.charges.hot_water}}
        td.center.aligned {{record.charges.electricity}}
        td.center.aligned {{record.charges.kitchen}}

        td.center.aligned.shadow
          .ui.label(v-if='record.state.text', :class='record.state.color') {{record.state.text}}

        td.center.aligned(:style='severity(record, "water")') {{record.average_usage.water.toFixed(1)}}
        td.center.aligned(:style='severity(record, "hot_water")')  {{record.average_usage.hot_water.toFixed(1)}}
        td.center.aligned(:style='severity(record, "electricity")')  {{record.average_usage.electricity.toFixed(1)}}
        td.center.aligned {{record.average_usage.kitchen.toFixed(1)}}

</template>
s
<script>
import tinycolor from 'tinycolor2'
import { MixRoom } from '../mixins'

export default {
  name: 'utilities-monitor',
  mixins: [MixRoom],
  mounted() {
    this.$store.dispatch('load_charges')
  },
  methods: {
    deviation(record, attr) {
      const average = this.avarage[attr]
      const value = record.average_usage[attr]

      return (value - average) / average
    },
    severity(record, attr) {
      let deviation = this.deviation(record, attr)
      let abs = Math.abs(deviation)
      const sign = deviation / abs
      abs = Math.max(abs - 0.5, 0)
      deviation = sign * abs

      let normalized = Math.atan(abs) / (Math.PI / 2)

      if (record.untrusted) {
        deviation = 0
        abs = 0
        normalized = 0
      }

      return {
        background: tinycolor({ h: 0 + (90 * normalized * sign), s: normalized, v: 1, a: 1 }).toHexString(),
      }
    },
  },
  computed: {
    rooms() {
      return this.$store.state.summary.rooms.filter(i => i.avaliable)
    },
    avarage() {
      const usages = this.details.filter(r => !r.untrusted).map(r => r.average_usage)
      const total = {}
      const slicing = Math.round(usages.length * 0.05)

      total.electricity = usages.map(u => u.electricity)
        .sort()
        .slice(slicing)
        .splice(slicing)
        .reduce((a, b) => a + b, 0)
      
      total.water = usages.map(u => u.water)
        .sort()
        .slice(slicing)
        .splice(slicing)
        .reduce((a, b) => a + b, 0)

      total.hot_water = usages.map(u => u.hot_water)
        .sort()
        .slice(slicing)
        .splice(slicing)
        .reduce((a, b) => a + b, 0)

      total.kitchen = usages.map(u => u.kitchen)
        .sort()
        .slice(slicing)
        .splice(slicing)
        .reduce((a, b) => a + b, 0)

      const result = {}
      for (const key of Object.keys(total)) 
        result[key] = total[key] / usages.length
      
      return result
    },
    details() {
      const now = this.$moment()
      const from = this.$moment('2017-07-20T00:00:00.000+0000')

      return this.$store.getters.terminate_contracts.map(contract => {
        const room = this.$store.getters.room_by_id(contract._room)
        const contracts = this.$store.getters.contracts_chain(contract)
        const customers = this.$store.getters.customers_of_contract(contract)
 
        let rented_days = 0
        for (const c of contracts) {
          let expire = this.$moment(c.date_checkout || c.date_expire)
          let start = this.$moment(c.date_start)

          if (expire > now) expire = now
          if (from > start) start = from
          if (expire > start)
            rented_days += this.$formatters.date.days_in_between(expire, start)
        }

        if (rented_days <= 0)
          return null

        const room_utilities = {
          electricity: 0,
          water: 0,
          hot_water: 0,
          kitchen: 0,
        }
        for (const u of room.utilities) 
          room_utilities[u.type] = u.balance
        
        const charges_records = this.$store.getters.charges_of_contracts(contracts)
        const charges = {
          electricity: 0,
          water: 0,
          hot_water: 0,
          kitchen: 0,
        }
        for (const r of charges_records) {
          for (const u of r.utilities) 
            charges[u.type] = (charges[u.type] || 0) + u.quantity
        }

        const usage = {
          electricity: room_utilities.electricity + charges.electricity,
          water: room_utilities.water + charges.water,
          hot_water: room_utilities.hot_water + charges.hot_water,
          kitchen: room_utilities.kitchen + charges.kitchen,
        }

        if (contract.checkout && contract.checkout.utilities) {
          for (const u of contract.checkout.utilities) 
            usage[u.type] -= u.balance
        }

        const average_days = 30
        const average_usage = {
          electricity: ((usage.electricity / rented_days / customers.length) * average_days || 0),
          water: ((usage.water / rented_days / customers.length) * average_days || 0),
          hot_water: ((usage.hot_water / rented_days / customers.length) * average_days || 0),
          kitchen: ((usage.kitchen / rented_days / customers.length) * average_days || 0),
        }

        const state = {
          text: '',
          color: 'green',
        }
        let untrusted = false
        if (!contracts.length) {
          state.text = '空房'
          state.color = 'olive'
          untrusted = true
        } else if (rented_days < average_days) {
          state.text = '入住时间过短'
          state.color = 'teal'
          untrusted = true
        }

        if (contract.state === 'ended') {
          state.text = '已退房'
          state.color = 'orange'
        }

        return {
          no: room.no,
          contracts,
          customers,
          rented_days,
          charges,
          usage,
          state,
          untrusted,
          room_utilities,
          average_usage,
        }
      }).filter(a => a).sort((a, b) => (a.no.localeCompare(b.no)))
    },
  },
}
</script>

<style lang="less" scoped>
td.customers {
  max-width: 200px;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow: hidden;
}

td.shadow{
  background: rgba(0,0,0,0.025);
}
</style>



// WEBPACK FOOTER //
// UtilitiesMonitor.vue?30d2c9fb